import cn from 'classnames';
import styles from './Tag.module.scss';

interface TagProps {
    type: 'format' | 'date' | 'rubric';
    content: string;
}

export const Tag = ({ type, content }: TagProps) => {
    return (
        <div
            className={cn(styles.tag, {
                [styles.tag__date]: type === 'date',
                [styles.tag__format]: type === 'format',
                [styles.tag__rubric]: type === 'rubric',
                [styles.tag__blue]: type === 'format' && content === 'Онлайн',
                [styles.tag__red]: type === 'format' && content === 'Офлайн',
            })}
        >
            <span>{content}</span>
        </div>
    );
};
